<template>
    <div>
        <AppSwitch :value="template.enabled"
                   @click.native.stop
                   @toggle="onTemplateToggle"
                   class="d-inline-block mr-3">
            <div slot="label">
                Visible
                <span
                    v-tooltip="`Template will be <b>${template.enabled ? 'visible' : 'hidden' }</b> in the automation center for the user`"
                    class="ml-1">
                    <i class="fal fa-info-circle"></i>
                </span>
            </div>
        </AppSwitch>
        <button @click.stop="onTemplateDelete"
                class="btn btn-sm text-danger float-right">
            <i class="fal fa-trash-alt"></i>
        </button>
    </div>
</template>

<script>
import {withConfirmation} from '@/decorators/withConfirmation'
import {automationsApi} from '@/api/automations'
import {showErrorMessage} from '@/services/snackbar'
import AppSwitch from '../../../../components/shared/AppSwitch'

export default {
    name: 'AutomationTemplateActions',
    components: {AppSwitch},
    props: {
        template: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            open: false,
            isUpdating: false,
            isDeleting: false
        }
    },
    methods: {
        hide() {
            this.open = false
        },

        onTemplateDelete() {
            withConfirmation({
                onConfirm: this.deleteTemplate,
                title: 'Delete template',
                description: 'Are you sure you want to delete this template?'
            })
        },

        async deleteTemplate() {
            this.isDeleting = true
            this.hide()
            const {error} = await automationsApi.delete(this.template.uuid)
            if (error) {
                showErrorMessage('Failed to delete template')
            } else {
                this.$emit('deleted', this.template)
            }
            this.isDeleting = false
        },

        async onTemplateToggle() {
            this.isUpdating = true
            this.hide()
            // TODO: remove extra fetch request (recipe will optional later - it allows updating 'enabled' flag directly)
            const {error, data} = await automationsApi.fetch(this.template.uuid)
            if (error) {
                showErrorMessage('Failed to update template')
            } else {
                data.enabled = !data.enabled
                const {error} = await automationsApi.update({id: this.template.uuid, data})
                if (error) {
                    showErrorMessage('Failed to update template')
                } else {
                    this.$emit('change', data)
                }
            }
            this.isUpdating = false
        }
    }
}
</script>

<style scoped lang="scss">
.custom-control {
    padding-top: 3px;

    .custom-control-label {
        padding-top: 3px;
    }
}
</style>
